/*!
 *
 *  waitTransition.ts
 *
 */
export default function waitTransition(elem, propertyName, callback, options = {}) {
    const { duration, reducedMotionBehavior = 'skip', } = options;
    let done = false;
    let timer;
    let onEnd;
    let onCancel;
    const cleanup = () => {
        if (onEnd) {
            elem.removeEventListener('transitionend', onEnd);
        }
        if (onCancel) {
            elem.removeEventListener('transitioncancel', onCancel);
        }
        if (timer !== undefined) {
            clearTimeout(timer);
        }
    };
    const complete = () => {
        if (done)
            return;
        done = true;
        cleanup();
        callback();
    };
    const cancel = () => {
        if (done)
            return;
        done = true;
        cleanup();
    };
    onEnd = (e) => {
        if (e.target !== elem)
            return;
        if (e.propertyName !== propertyName)
            return;
        complete();
    };
    onCancel = (e) => {
        if (e.target !== elem)
            return;
        if (e.propertyName !== propertyName)
            return;
        complete();
    };
    // reduce motionを設定している場合の挙動（即時実行）
    if (util.reducedMotion && reducedMotionBehavior === 'skip') {
        complete();
        return cancel;
    }
    elem.addEventListener('transitionend', onEnd);
    elem.addEventListener('transitioncancel', onCancel);
    timer = window.setTimeout(complete, duration ?? getTransitionDuration(elem));
    return cancel;
}
function getTransitionDuration(elem) {
    const style = window.getComputedStyle(elem);
    const durations = style.transitionDuration.split(',');
    const delays = style.transitionDelay.split(',');
    const toMs = (v) => {
        const n = parseFloat(v) || 0;
        return v.includes('ms') ? n : n * 1000;
    };
    const totals = durations.map((d, i) => {
        const delay = delays[i] ?? delays[0] ?? '0s';
        return toMs(d) + toMs(delay);
    });
    return Math.max(...totals, 0) + 50;
}
